<template>
  <NuxtLayout name="seminar-lp">
    <template #title>
      <span style="font-size:1rem;">【法律を学んだ方／法務部員を目指している方】</span>
      <h1>{{ pageTitle }}</h1>
      <h2>～{{ pageSubTitle }}～</h2>
      <v-chip class="attorneys-seminar ma-2" label>
        ウェビナー
      </v-chip>
    </template>
    <template #main-visual>
      <div v-show="isExpiredApply" style="background-color:#aeaeae;">このセミナーは終了しました</div>
      <v-img width="100%" heghit="100%" :aspect-ratio="960/540" preload contain class="mv mx-auto" src="/img/seminar/202506/mv.webp" type="image/webp" alt="セミナー">
        <source width="960" heghit="540" srcset="/img/seminar/202506/mv.png" type="image/png" />
      </v-img>
    </template>
    <template #detail>
      <p class="heading-4 text-center ma-2" style="font-size:larger;font-weight:bold;">
        法律を学んできたその先に、<br class="d-sm-none" />もう一つの選択肢がある。
      </p>
      <p>
        それが、企業というリアルな現場で法を活かす「企業法務」の世界です。<br />
        本セミナーでは、実務の最前線で活躍する講師が、法務部のリアルな仕事とその魅力を一気に解説。<br />
        契約審査やコンプライアンスにとどまらず、<strong>経営との接点、組織の設計、現場での意思決定</strong>まで、<br />
        法律がどのように“生きた力”になるのかを丁寧にひもときます。<br />
        <strong>ロースクール卒業生、法務志望の学生、キャリアを再考する社会人へ。</strong><br />
        法律知識を、社会を動かす力に変えたいと願うあなたに、<br />
        “<strong>キャリアの地図</strong>”が見えてくる40分。<br />
        <strong>自分の「これから」の可能性に気づくきっかけとして、未来を動かす入口がここにあります。</strong>
      </p>
      <dl>
        <dt>
          <h3>主催</h3>
        </dt>
        <dd>
          Attorney's MAGAZINE 編集部<br />
          株式会社C&Rリーガル･エージェンシー社
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>日時</h3>
        </dt>
        <dd>2025年6月19日（木）19:00～</dd>
      </dl>
      <dl>
        <dt>
          <h3>申込期日</h3>
        </dt>
        <dd>
          2025年6月19日（木）18:30
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>参加対象者</h3>
        </dt>
        <dd>
          <ul>
            <li>
              企業法務部の仕事に興味がある方<br />
              ┗ 法務部員の業務内容や働き方を知りたい
            </li>
            <li>
              せっかく学んだ法律知識を活かしたい方<br />
              ┗ 法律資格をお持ちか法律資格の受験経験があり、法務部員としてその能力を活かしたい
            </li>
            <li>
              法務部員としてスキルアップしたい方<br />
              ┗ 一人で手探りで法務の仕事をしている、他社の法務担当のお話を聞きたい
            </li>
            <li>
              法務部員としてのキャリア形成に興味がある方<br />
              ┗ さらに活躍するために今、何をすべきか知りたい
            </li>
          </ul>
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>会場</h3>
        </dt>
        <dd>
          オンライン
          <ul class="notice">
            <li>当日の参加URLはオンラインセミナー当日までにメールにてお知らせいたします。</li>
            <li>
              ご視聴の環境により、セミナーのご視聴ができない可能性がございます。<br />
              その場合、申込完了後のメールに記載しているメールアドレスまでご連絡ください。
            </li>
          </ul>
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>注意事項</h3>
        </dt>
        <dd>
          <ul class="notice">
            <li>同業他社からのお申込はお断りさせていただきます。</li>
            <li>申込者多数の場合は抽選となる可能性がございますので、ご了承ください。</li>
            <li>都合によりプログラムの内容・登壇者が変更となる場合がございます。</li>
          </ul>
        </dd>
      </dl>
      <h3>登壇者</h3>
      <AppCardSpeakerCard v-for="speaker in speakers" :speaker="speaker" />
    </template>
    <template #form>
      <AppForm202506SeminarStepForm class="mx-auto" :isExpiredApply="isExpiredApply" />
    </template>
    <template #bottom-navigation>
      <AppBottomNavigationsGotoApplication v-if="isExpiredApply === false" targetQuerySelector="#application" :targetElementTopOffset="-64" />
    </template>
  </NuxtLayout>
</template>
<script setup lang="ts">
import type { Speaker } from '@/types/person';

const runtimeConfig = useRuntimeConfig();
const pageTitle : string = 'キャリアの地図に「企業法務」を描く';
const pageSubTitle : string = '現役法務部長が語るリアル';
const pageDescription : string = 'ロースクール生、法務部員を目指す方、キャリアに悩んでいる法務部員の方必見。現役企業法務部長が法務部のキャリアについて語るオンラインキャリアセミナーです。';
const expiredTImeForApplySeminar: string = '2025-06-19T18:30:00.000+09:00';

const isExpiredApply: boolean = (new Date()).getTime() > new Date(expiredTImeForApplySeminar).getTime();

const speakers: Speaker[] = [
  {
    name: '西澤 朋晃 氏',
    job_role: 'GMOフィナンシャルゲート株式会社<br />コーポレートサポート本部 法務部 部長',
    image: {
      alt: '講師 西澤 朋晃 氏',
      proper: {
        src: "/img/seminar/202506/nishizawa.jpg",
        type: 'image/jpg',
      },
      webp: {
        src: "/img/seminar/202506/nishizawa.webp",
        type: 'image/webp',
      },
    },
    biography: '2008年中央大学法学部卒業、その後法科大学院も卒業し、約3年間の休憩を経て東証プライム上場の大手企業にて法務キャリアをスタート。2018年から現職で一人法務として法務組織を立ち上げ、契約法務、商事法務全般、コンプライアンス、稟議事務局等決裁制度の仕組み側まで幅広く担う。自分が所属したいと想う「魅力的な法務部」を創り「向上心の塊」であり続けることを理想に掲げてチームビルディング。企業法務とは「法務という専門性を駆使するビジネスマンである」と定義し、未来を現実に引き直した緻密な戦略を描き、先駆的なアイデアを実践しつつ攻守コンプリートを企む。',
  }
];

definePageMeta({
  isr: {
    revalidate: 3600,
  }
});

useHead({
  link: [
    {
      rel: 'preload',
      fetchpriority: "high",
      type: "image/png",
      href: `/img/seminar/202506/mv.png`,
      as: 'image',
    },
    {
      rel: 'preload',
      fetchpriority: "high",
      type: "image/webp",
      href: `/img/seminar/202506/mv.webp`,
      as: 'image',
    },
    {
      rel: 'canonical',
      href: `${runtimeConfig.public.appUrlOrigin}/seminar/202506`,
    },
  ],
  script: [
    {
      key: "event-schema",
      type: 'application/ld+json',
      textContent: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Event",
        "name": "2025年6月セミナー｜【法律を学んだ方／法務部員を目指している方】キャリアの地図に「企業法務」を描く ～現役法務部長が語るリアル～",
        "description": "一人法務として入社後、0から法務組織を構築し、現在も組織強化を進めているGMOフィナンシャルゲート株式会社 法務部長 西澤 朋晃 氏をお招きし、企業法務の実態とキャリア形成のヒントをお話しいただきます。",
        "startDate": "2025-06-19T19:00:00+09:00",
        "endDate": "2025-06-19T20:00:00+09:00",
        "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",
        "eventStatus": "https://schema.org/EventScheduled",
        "location": {
          "@type": "VirtualLocation",
          "url": `${runtimeConfig.public.appUrlOrigin}/seminar/202506`,
        },
        "image": [
          `${runtimeConfig.public.appUrlOrigin}/img/seminar/202506/mv.png`,
        ],
        "offers": {
          "@type": "Offer",
          "url": `${runtimeConfig.public.appUrlOrigin}/seminar/202506`,
          "price": 0,
          "priceCurrency": "JPY",
          "availability": "https://schema.org/InStock",
        },
        "performer": {
          "@type": "Person",
          "name": "西澤 朋晃"
        },
        "organizer": {
          "@type": "Organization",
          "name": "C&Rリーガル･エージェンシー社",
          "url": "https://legal-agent.jp/",
        },
      }),
    },
  ],
});
useSeoMeta({
  title: '【法律を学んだ方／法務部員を目指している方】キャリアの地図に「企業法務」を描く ～現役法務部長が語るリアル～',
  description: pageDescription,
  keywords: '企業法務, 法務部 キャリア, 法務職 転職, 法学部 就職先, 法律系 就職, インハウスロイヤー, 法務部 就職活動, 法律職 セミナー, 法務部のリアル, 法律専門職 キャリアセミナー, オンライン法務セミナー',
  ogUrl: `${runtimeConfig.public.appUrlOrigin}/seminar/202506`,
  ogTitle: '【法律を学んだ方／法務部員を目指している方】キャリアの地図に「企業法務」を描く ～現役法務部長が語るリアル～',
  ogDescription: pageDescription,
  ogImageUrl: `${runtimeConfig.public.appUrlOrigin}/img/seminar/202506/mv.png`,
});
</script>
